export enum OnlineFormSubmissionFields {
    FORM = 'form',
    DATA = 'data',
    DURATION_IN_SEC = 'durationInSec',
    INSTITUTION = 'institution',
    HANDOUT_EVENT = 'handoutEvent',
    STATE = 'state',
    CONFIRMATION_FILE = 'confirmationFile',
}
